import { TeamCard } from '../widgets/PlayerTeamsWidget'
import { teamHref } from '../destinations'
import type { MyTeam } from '../../../api/teams'
import styles from './home.module.css'

/**
 * The teams you play on. Each opens the team — whatever you may do to it;
 * managing a roster is its own action, in To do or the club's panel.
 */
export function YourTeams({ teams }: { teams: MyTeam[] }) {
  if (teams.length === 0) return null
  return (
    <section aria-labelledby="home-teams" className={styles.section} data-panel="Your teams">
      <div className={styles.sectionHead}>
        <h2 id="home-teams" className={styles.sectionTitle}>Your teams</h2>
      </div>
      <div className={styles.teams}>
        {teams.map((team) => (
          <TeamCard key={team.id} team={team} to={teamHref(team)} />
        ))}
      </div>
    </section>
  )
}
